import { render, staticRenderFns } from "./CatalogoView.vue?vue&type=template&id=6f0b88dc&scoped=true"
import script from "./CatalogoView.vue?vue&type=script&lang=js"
export * from "./CatalogoView.vue?vue&type=script&lang=js"
import style0 from "./CatalogoView.vue?vue&type=style&index=0&id=6f0b88dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b88dc",
  null
  
)

export default component.exports